module.exports = __webpack_public_path__ + "static/img/A (1).0b9022c5.png";